// Français

export default {
    'About': '',
    'Company': 'Société',
    'Contact': 'Contact',
    'Email Address': 'Adresse e-mail*',
    'First Name': 'Prénom',
    'Get In Touch': 'Démarrez',
    'Manage Cookies': '',
    'Media Kit': '',
    'Newsroom': '',
    'Password': '',
    'Privacy Policy': '',
    'Related Case Studies': '',
    'Related Resources': 'Ressources associées',
    'See Case Study': 'Soumettre',
    'Sign up': 'S’inscrire',
    'Submit': 'Soumettre',
    'The Goal': '',
    'View All': 'Tout afficher',
    'You are missing one or more requred fields': ''
};
